
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Social Media Marketing in Goa to get you sales, not just likes",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'We deliver market leading social media advertising and marketing campaigns that transform Goa businesses, large & small, and connect with your audience'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'social media marketing in goa, social media marketing agency in goa, social media marketing strategy in goa, social media marketing services in goa'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'We deliver market leading social media advertising and marketing campaigns that transform Goa businesses, large & small, and connect with your audience'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'We deliver market leading social media advertising and marketing campaigns that transform Goa businesses, large & small, and connect with your audience'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Social Media Marketing in Goa to get you sales, not just likes'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'We deliver market leading social media advertising and marketing campaigns that transform Goa businesses, large & small, and connect with your audience'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Social Media Marketing in Goa to get you sales, not just likes'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/social-media.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/social-media.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/social-media.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Social Media Marketing in Goa to get you sales, not just likes',
      description: 'We deliver market leading social media advertising and marketing campaigns that transform Goa businesses, large & small, and connect with your audience',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Digital Marketing Services in Goa",
                "url": "/digital-marketing"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Search Engine Optimization in Goa",
                "url": "/search-engine-optimization"              
		},
              {
                "name": "Advertising in Goa",
                "url": "/Advertising"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },

jsonld() {
  return {
    '@context': 'https://schema.org',
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://goa.app/social-media-marketing/#Service",
        "url": "https://goa.app/social-media-marketing",
        "name": "Social Media",
        "description": "We provide Best Social Media Marketing services for your business growth. Social Media Optimization, Ads, Content Creation, & more.",
      "datePublished": "2024-06-14T00:00:00",
      "dateModified":  "2024-06-14T00:00:00",
        "image": "https://goa.app/img/service-imgs/social-media.webp",
        "serviceType": "Digital Marketing",
        "additionalType": "serviceOutput",
        "providerMobility": "provider",
        "provider": {
          "@type": "Corporation",
          "name": "Goa App",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Goa",
            "postalCode": "403505"
          },
          "telephone": "+91 9049248689"
        },
        "areaServed": {
          "@type": "City",
          "name": "Goa"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Social Media",
          "itemListElement": [
            {
              "@type": "Offer",
              "name": "Strategy Development"
            },
            {
              "@type": "Offer",
              "name": "Platform Selection"
            },
            {
              "@type": "Offer",
              "name": "Content Creation"
            },
            {
              "@type": "Offer",
              "name": "Engagement and Community Management"
            },
            {
              "@type": "Offer",
              "name": "Advertising and Promotion"
            },
            {
              "@type": "Offer",
              "name": "Influencer Marketing"
            },
            {
              "@type": "Offer",
              "name": "Analytics and Reporting"
            },
            {
              "@type": "Offer",
              "name": "Collaboration and Cross-Promotion"
            },
            {
              "@type": "Offer",
              "name": "Campaigns and Contests"
            }
          ]
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How do social media benefit my small business?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Forget the high costs and wide-net approach of traditional media like print ads and TV commercials. Social media is your cost-effective powerhouse! You can measure every action, from post reach to ad results, and demographic engagement. As one of the top social media marketing agencies, Goa App ensures your marketing budget hits the bullseye, guiding you to social media success with precision."
            }
          },
          {
            "@type": "Question",
            "name": "How much does social media marketing cost?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "At Goa App, we understand that one size doesn’t fit all. Our social media marketing packages are tailored to your specific needs. Whether you need daily posts or just a few a month, our flexible pricing ensures you get the best value. We customize our services to match your business goals and budget."
            }
          },
          {
            "@type": "Question",
            "name": "Does my brand really need social media?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Absolutely! Digital marketing places your brand where your customers are – on social media. Most adults spend 1-2 hours daily on these platforms. With such a cost-effective way to engage thousands of potential customers daily, it’s a no-brainer. Goa App ensures your brand message reaches the right audience, driving engagement and growth."
            }
          },
          {
            "@type": "Question",
            "name": "How do social media ads work and how much does it cost?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Social media ads are all about targeting interests, unlike Google Ads which are search-based. As your social media agency, Goa App carefully selects your ad audience based on age, location, interests, and more. We ensure transparency, giving you access to ad accounts and providing regular performance updates. Ad spend varies widely, but remember – the more you invest in these platforms, the better your results will be. Let’s make every penny count!"
            }
          }
        ]
      }
    ]
  };
},
  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
